// src/layout/AppFooter.tsx
import React from 'react';
import { Box, Container, Typography, Link, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/common/LanguageSwitcher';

const AppFooter: React.FC = () => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <Box
            component="footer"
            sx={{
                py: 2, // Reduced padding
                px: 2,
                mt: 'auto', // Key for sticky footer
                backgroundColor: (theme) =>
                    theme.palette.mode === 'light' ? theme.palette.grey[900] : 'background.paper',
                color: (theme) => theme.palette.getContrastText(
                    theme.palette.mode === 'light' ? theme.palette.grey[900] : theme.palette.grey[900]
                ),
            }}
        >
            <Container maxWidth="lg">
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: 2
                    }}
                >
                    <Typography variant="body2" color="inherit">
                        {t('copyright', { year: currentYear })}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: {xs: 1, sm: 3}, flexWrap: 'wrap' }}>
                        <Link component={RouterLink} to="/about" color="inherit" underline="hover">{t('about_us')}</Link>
                        <Link component={RouterLink} to="/terms" color="inherit" underline="hover">{t('terms_of_service')}</Link>
                        <Link component={RouterLink} to="/privacy" color="inherit" underline="hover">{t('privacy_policy')}</Link>
                        <Link component={RouterLink} to="/contact" color="inherit" underline="hover">{t('contact_us')}</Link>
                        <Box sx={{ width: { xs: 0, sm: 40 } }} /> {/* Spacer for LanguageSwitcher */}
                        <LanguageSwitcher isInFooter={true} />
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default AppFooter;